import { Alert, Badge, Group, Paper, Switch, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useActivitySettings, useSetActivityConsent } from '@/api/activity';
import { useCurrentWorkspace } from '@/app/WorkspaceContext';
import { useApiError } from '@/hooks/useApiError';

/** Eigene Zustimmung zur Standorterfassung (ACT-04). Widerruf löscht die gespeicherten Standorte. */
export function LocationConsentSection() {
  const { t } = useTranslation();
  const ctx = useCurrentWorkspace();
  const allowed = ctx.hasFeature('ACTIVITY') && ctx.hasFeature('GPS');
  const { data } = useActivitySettings(ctx.workspaceId, allowed);
  const consent = useSetActivityConsent(ctx.workspaceId);
  const onError = useApiError();
  if (!allowed || !data?.gpsEnabled) return null;
  return (
    <Paper withBorder p="md">
      <Group justify="space-between" mb="xs">
        <Title order={5}>{t('activity.consentTitle')}</Title>
        <Badge color={data.consent ? 'orange' : 'gray'} variant="light">
          {data.consent ? t('activity.consentOn') : t('activity.consentOff')}
        </Badge>
      </Group>
      <Text size="sm" c="dimmed" mb="sm">
        {t('activity.consentText', { interval: Math.round(data.intervalSeconds / 60) || 1, days: data.retentionDays })}
      </Text>
      <Switch
        label={t('activity.consentSwitch')}
        checked={data.consent}
        disabled={consent.isPending}
        onChange={(e) => {
          const on = e.currentTarget.checked;
          if (on && 'geolocation' in navigator) navigator.geolocation.getCurrentPosition(() => undefined, () => undefined);
          consent.mutate(on, { onError });
        }}
      />
      <Alert color="gray" variant="light" mt="sm">
        {t('activity.backgroundHint')}
      </Alert>
    </Paper>
  );
}
